/**
 * Логотип платформы + подпись в шапке (app-shell__brand).
 * SVG: /public/img/logo.svg
 */
export function AppShellBrand({ children }) {
  const hasText = children != null && children !== false;
  return (
    <div className="app-shell__brand">
      <img
        className="app-shell__logo"
        src="/img/logo.svg"
        alt={hasText ? '' : 'AG.platform'}
        width={40}
        height={40}
        decoding="async"
      />
      {hasText && <span className="app-shell__brand-text">{children}</span>}
    </div>
  );
}
